import { render, staticRenderFns } from "./ConversationView.vue?vue&type=template&id=0df5b525&scoped=true"
import script from "./ConversationView.vue?vue&type=script&lang=ts"
export * from "./ConversationView.vue?vue&type=script&lang=ts"
import style0 from "./ConversationView.vue?vue&type=style&index=0&id=0df5b525&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df5b525",
  null
  
)

export default component.exports